import styles from "./ChatbotHeroSection.module.css";
import heroImage from "../../../Images/b9l34t1m.png";

const ChatbotHeroSection = () => {
    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                {/* Left Content */}
                <div className={styles.content}>
                    <h1 className={styles.title}>
                        Turn Website Visitors Into <br />
                        Leads — <span>Automatically</span>
                    </h1>

                    <p className={styles.description}>
                        ToxboxAI is a no-code AI chatbot that answers questions, guides users,
                        and completes forms for them in real time.
                    </p>

                    <p className={styles.subText}>
                        No delays. No confusion. Just conversions.
                    </p>

                    <div className={styles.actions}>
                        <button className={styles.primaryBtn}>
                            Start — Launch in Minutes →
                        </button>
                        <button className={styles.secondaryBtn}>
                            Watch Demo
                        </button>
                    </div>
                </div>

                {/* Right Image */}
                <div className={styles.imageWrapper}>
                    <img src={heroImage} alt="AI Chat Interface" />
                </div>
            </div>
        </section>
    );
};

export default ChatbotHeroSection;